import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { Content } from 'core/layouts';
import { toDate } from 'core/utils';
import { BaasicButton, BasicCheckbox, BaasicConfirmModal } from 'core/components';

function FacilityOrderNewFlowNonScheduledTubesModalTemplate({ facilityOrderNewFlowNonScheduledTubesModalStore }) {
    const {
        loaderStore: { loading },
        items,
        isLoading,
        setIncludeNotCurrentTube,
        confirmTubes,
        sendOrder,
        addTubeConfirmModal,
        saveTubes,
        isSaveLoading,
        isNotCurrentTubeAdded,
        disabledSendOrder
    } = facilityOrderNewFlowNonScheduledTubesModalStore;
    return (
        <div style={{ minHeight: 80 }}>
            <Content loading={loading}>
                <div className="modal__header">
                    <span className="u-icon u-icon--med u-icon--filter-calendar u-mar--right--tny"></span>
                    <h3 className='modal__header__title'>Non-Scheduled Tubes</h3>
                </div>
                <div className="modal__body">

                    <div className="u-mar--top--lrg">
                        <div className="u-mar--bottom--sml">The Tubes listed below are not scheduled to be sent with this order. Check off the tube to send it as "above allowable" with this order.</div>
                        <table className="table--preview">
                            <thead>
                                <tr>
                                    <th width="4%" className="type--center">Add</th>
                                    <th width="25%" className="type--left">Patient Name</th>
                                    <th width="*" className="type--left">Item Name</th>
                                    <th width="14%" className="type--left">Item Id</th>
                                    <th width="14%" className="type--left">Next Run Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {items && items.map((item) => {
                                    return (
                                        <tr key={item.id}>
                                            <td className="type--center"><BasicCheckbox className='input--check input--check--no-label' id={item.id} checked={item.includeNotCurrentTube} onChange={() => setIncludeNotCurrentTube(item)} disabled={disabledSendOrder || isNotCurrentTubeAdded || isSaveLoading || isLoading } /></td>
                                            <td>{item.patientName}</td>
                                            <td>{item.description}</td>
                                            <td>{item.itemId}</td>
                                            <td className="type--right"> {item.nextRunDate && toDate(item.nextRunDate)} </td>
                                        </tr>
                                    );
                                })}
                                {(!items || !items.some(x => x.id)) && <tr><td colSpan={5} className="type--center"> No data to display. </td></tr>}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className='modal__footer is-right'>
                    <BaasicButton
                        className='btn btn--med btn--primary'
                        label={sendOrder ? "Confirm Tubes & Send Order" : "Add Tubes Now"}
                        onClick={async () => await confirmTubes()}
                        disabled={ disabledSendOrder || isNotCurrentTubeAdded || isSaveLoading || isLoading || !items || !items.some(x => x.id)}
                        rotate icon={
                            isLoading
                                ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                                : 'u-display--none'
                        }
                    />
                    {!sendOrder &&
                        <BaasicButton
                            className='btn btn--med btn--primary'
                            label="Save"
                            onClick={async () => await saveTubes()}
                            disabled={ disabledSendOrder || isNotCurrentTubeAdded || isSaveLoading || isLoading || !items || !items.some(x => x.id)}
                            rotate icon={
                                isSaveLoading
                                    ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                                    : 'u-display--none'
                            }
                        />
                    }
                </div>
                <BaasicConfirmModal modalParams={addTubeConfirmModal} />
            </Content>
        </div>
    )
}

FacilityOrderNewFlowNonScheduledTubesModalTemplate.propTypes = {
    facilityOrderNewFlowNonScheduledTubesModalStore: PropTypes.object
};

export default defaultTemplate(FacilityOrderNewFlowNonScheduledTubesModalTemplate);
